import { render, staticRenderFns } from "./TopPostCrad.vue?vue&type=template&id=3188057a&scoped=true&"
import script from "./TopPostCrad.vue?vue&type=script&lang=js&"
export * from "./TopPostCrad.vue?vue&type=script&lang=js&"
import style0 from "./TopPostCrad.vue?vue&type=style&index=0&id=3188057a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188057a",
  null
  
)

export default component.exports